export default __webpack_public_path__ + "static/media/thumb.0090d255.svg";